import { useEffect, useState } from 'react'
import { fetchTalk } from './api'

/**
 * Whether a camera can be heard: its own talk channel or an IP speaker paired
 * with it, as VMS reports. A typed message to a camera with neither can only
 * fail (#297), so anything short of the server saying so is no: while it is
 * asked, when it fails, and for another camera's late answer.
 */
export function useCanSpeak(siteId: string | null, camera: string | null): boolean {
  const key = siteId && camera ? `${siteId}\u0001${camera}` : null
  const [answer, setAnswer] = useState<{ key: string; can: boolean } | null>(null)

  useEffect(() => {
    if (!siteId || !camera || !key) return
    // An answer is kept with the camera it is for, so one arriving after
    // another camera was opened is never read as that camera's.
    fetchTalk(siteId, camera)
      .then((t) => setAnswer({ key, can: t.talk }))
      .catch(() => setAnswer({ key, can: false }))
  }, [siteId, camera, key])

  return !!key && answer?.key === key && answer.can
}
